import { render, staticRenderFns } from "./PeopleAdd.vue?vue&type=template&id=19585376&scoped=true&"
import script from "./PeopleAdd.vue?vue&type=script&lang=tsx&"
export * from "./PeopleAdd.vue?vue&type=script&lang=tsx&"
import style0 from "./PeopleAdd.vue?vue&type=style&index=0&id=19585376&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19585376",
  null
  
)

export default component.exports